import type { IconProps } from './icon.types'

const UserIcon = (props: IconProps) => (
  <svg
    width='16'
    height='16'
    viewBox='0 0 18 18'
    fill='none'
    stroke='currentColor'
    strokeWidth='1.1'
    strokeLinecap='round'
    strokeLinejoin='round'
    aria-hidden='true'
    data-testid='user-icon'
    {...props}
  >
    <circle cx='9' cy='6' r='3' />
    <path d='M3.5 15.5a5.5 5.5 0 0 1 11 0' />
  </svg>
)

export default UserIcon
